import keycloak from '../../keycloak';
import { uploadToS3 } from '../../utilities/apiHelper';
import { config } from '../../utilities/config';

export async function generateUploadApi(organizationId) {
  const response = await fetch(`${config.API_BASE_URL}/${organizationId}/bill-parsing/generate`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${keycloak.token}`
    },
    body: JSON.stringify({})
  });
  const result = await response.json();
  if (!response.ok) throw new Error(result.message || 'Failed to generate upload URL');
  return result;
}

export async function uploadBillToS3Api(organizationId, file) {
  const signedPost = await generateUploadApi(organizationId);
  const keyTemplate = signedPost.fields.key;
  const key = keyTemplate.replace(/\$\{filename\}/g, file.name);
  signedPost.fields.key = key;
  await uploadToS3(signedPost, file);
  return { key, name: file.name };
}

export async function fetchBillsListApi(organizationId, page = 1, limit = 20) {
  const response = await fetch(
    `${config.API_BASE_URL}/${organizationId}/bill-parsing/list`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${keycloak.token}`
      }
    }
  );
  const result = await response.json();
  if (!response.ok) throw new Error(result.message);
  return result;
}

export async function downloadBillApi(organizationId, fileId) {
  const response = await fetch(`${config.API_BASE_URL}/${organizationId}/bill-parsing/download/${fileId}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${keycloak.token}`
    }
  });
  const result = await response.json();
  if (!response.ok) throw new Error(result.message);
  return result;
}

export async function parseBatchApi(organizationId, files) {
  const response = await fetch(`${config.API_BASE_URL}/${organizationId}/bill-parsing/parse-batch`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${keycloak.token}`
    },
    body: JSON.stringify({ files })
  });
  const result = await response.json();
  if (!response.ok) throw new Error(result.message || 'Failed to parse bills');
  return result;
}

export async function saveBatchApi(organizationId, bills) {
  const response = await fetch(`${config.API_BASE_URL}/${organizationId}/bill-parsing/save-batch`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${keycloak.token}`
    },
    body: JSON.stringify({ bills })
  });
  const result = await response.json();
  if (!response.ok) throw new Error(result.message || 'Failed to save bills');
  return result;
}
